<style scoped>
img{
    cursor: pointer;
}
.vel-modal {
    z-index: 9998;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    background: rgba(0,0,0,.5)!important;
}
#kurulumTable button{
    float:right
}
.upload-btn-wrapper {
    position: relative;
    display: inline-block;
}
.upload-btn-wrapper input[type=file] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    width:50px;
    height:35px
}
</style>
<script>
import VueEasyLightbox from "vue-easy-lightbox";
import Loader from "@/components/widgets/loader.vue";
import { Icon} from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { notify } from '@/helpers/notify' 
import Vue from 'vue'

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
    name: 'KurulumModal',
    props:[
        "data",
        "modelOpen"
    ],
    components: {
        LMap,
        LTileLayer,
        LMarker,
        VueEasyLightbox,
        Loader
  },
    data() {
        return {
            form: {},
            submitted: false,
            dataLoading:true,
            selectedFiles: {},
            images:
                {
                    "kurulum":  { filename:'', id:''},
                    "anten":  { filename:'', id:''},
                    "kapi":  { filename:'', id:''},
                    "adaptor":  { filename:'', id:''},
                },
            zoom: 25,
            center: [0.0, 0.0],
            coordinate: [0.0, 0.0], 
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            map: null,
            rows:[
                { code: 'kurulum', title: 'Anten Kurulum Resmi' },
                { code: 'anten', title: 'Anten Uzaktan Resmi' },
                { code: 'kapi', title: 'Dış Kapı Resmi Görüntüle' },
                { code: 'adaptor', title: 'Adaptör Resmi Görüntüle' },
            ],
            extraData: {
                address:null,
                services:[
                    { 
                        assigned_user_name:null,
                        user_name:null,
                        created_at:null,
                        done_at:null,
                    }
                ]
            },
            showImage:null,
            imageUrl:this.$http.defaults.baseURL + '/image/subscriptions/'
        };
    }, 
    computed:{
        modalTitle(){ return "Kurulum Detayı" },
    }, 
    watch:{
        modelOpen(){
            this.selectedFiles= {},
            this.images=
                {
                    "kurulum":  { filename:'', id:''},
                    "anten":  { filename:'', id:''},
                    "kapi":  { filename:'', id:''},
                    "adaptor":  { filename:'', id:''},
                }
            this.zoom= 25,
            this.center= [0.0, 0.0],
            this.coordinate= [0.0, 0.0], 
            this.showImage= null,
            this.form= {...this.data}
            this.getImages()
            setTimeout(() => {
                document.getElementById('_map').style.height = "300px"
                this.$refs.map.mapObject._onResize();
                this.dataLoading = false
            }, 1000);
        }
    },
    methods: {
        async uploadImage(event, name){
            const file = event.target.files[0];
            const resizedBlob = await this.resizeImage(file, 800); 
            const formData = new FormData();
            formData.append(`images[${name}]`, resizedBlob);
            const response = await this.$http.post('/image?subsId=' + this.form.id, formData, {headers: { 'Content-Type': 'multipart/form-data' }});
          
            if(response.data.error){
               return notify.error(response.data.message)
            }
            
            this.getImages()
            return notify.success(response.data.message)
           
        },
        async resizeImage(file, maxWidth) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = (readerEvent) => {
                const image = new Image();
                image.onload = () => {
                    const { width, height } = this.calculateAspectRatioFit(image.width, image.height, maxWidth);
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                    canvas.toBlob((blob) => {
                    resolve(blob);
                    }, file.type);
                };
                image.src = readerEvent.target.result;
                };
                reader.readAsDataURL(file);
            });
        },
        calculateAspectRatioFit(srcWidth, srcHeight, maxWidth) {
            const ratio = maxWidth / srcWidth;
            return { width: maxWidth, height: srcHeight * ratio };
        },
        getImages(){
            this.dataLoading = true
            this.$http.get('/members/' + this.form.id + '/imageAndCoordinate')
            .then(response => {
                let koordinatDizi = response.data.coordinate.split(",").map(coord => parseFloat(coord.trim()));
                this.center = koordinatDizi
                this.coordinate = koordinatDizi
                setTimeout(() => {
                    document.getElementById('_map').style.height = "300px"
                    this.$refs.map.mapObject._onResize();
                }, 1000);

  

                response.data.images.map(e=>{
                    this.images[e.name] = { filename: e.filename, id:e.id, created_at: e.created_at, username: e.user_name}
                })

                
                this.extraData = {
                    address: response.data.address,
                    services: [
                        { 
                            assigned_user_name: response.data?.services[0].assigned_user_name, 
                            user_name:  response.data?.services[0].user_name, 
                            created_at: response.data?.services[0].created_at, 
                            done_at:  response.data?.services[0].done_at, 
                        }
                    ]
                }
            })
        },
        close(){
            this.$parent.$bvModal.hide('kurulum_modal')
        },

        konumGuncelle(){
             this.$http.put(`members/kb_update`, { id:this.form.id , type:'coordinate', coordinate:this.coordinate })
                        .then((resp) => notify.success(resp.data.message))
        },
        sil(id, code){
            Vue.swal({
                title: "Silinecek?",
                showCancelButton: true,
                cancelButtonText: "İptal",
                confirmButtonText: "Sil"
            }).then((result) => {
                if (result.value) {
                    this.$http.delete(`/image/` + id)
                    .then(response => {
                        this.images[code] =  { filename:'', id:''}
                        if(response.data.code == 100) return notify.success(response.data.message)
                        
                      
                        return notify.error(response.data.message)
                    })
                }
            });

        },
        openInGoogleMaps() {
            
            const googleMapsUrl = `https://www.google.com/maps?q=${this.coordinate[0]},${this.coordinate[1]}`;
            window.open(googleMapsUrl, '_blank');
        }
    },
};
</script>

<template>
<b-modal id="kurulum_modal"  size="lg" :title="modalTitle"  no-close-on-backdrop hide-footer>
    <Loader :loading="true" :load="dataLoading">
    <div class="row">
        <div class="col-md-12">
            <div class="input-group" v-if="form.action != 'read'">
                <input type="text" class="form-control" v-model="coordinate" placeholder="36.8437291,30.7694648"/>
                <div class="input-group-append">
                    <b-button 
                        @click="konumGuncelle"
                        variant="success" 
                        class="ms-1"
                        >Güncelle
                    </b-button>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-between my-2">
                Açık Adres : {{  extraData.address }} 
                <b-button 
                    type="submit" 
                    @click="openInGoogleMaps"
                    variant="warning" 
                    class="ms-1"
                    >Konuma Git
                </b-button>
            </div>
            <div class="mb-3">
                <l-map
                    id="_map"
                    ref="map" 
                    :zoom="zoom"
                    :center="center"
                >
                    <l-tile-layer :url="url"  />
                    <l-marker :lat-lng="coordinate">
                    </l-marker>
                </l-map>
            </div>
        </div>
    </div>
    <div class="row" style="background-color: #fbfbfb;">
        <div class="col-md-12"> 
            <div>
                <table class="table table-border">
                    <tbody>
                        <tr>
                            <th colspan="2" class="text-center">Kurulum Bilgileri</th>
                        </tr>
                        <tr>
                            <th>İşlemi Yapan:</th>
                            <td>{{ extraData.services[0].assigned_user_name }}</td>
                        </tr>
                        <tr>
                            <th>İşlemi Açan:</th>
                            <td>{{ extraData.services[0].user_name }}</td>
                        </tr>
                        <tr>
                            <th>İşlemi Açıldığı Tarih:</th>
                            <td>{{ extraData.services[0].created_at }}</td>
                        </tr>
                        <tr>
                            <th>İşlemin Tamamlandığı Tarih:</th>
                            <td>{{ extraData.services[0].done_at }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="row">
         <div class="col-md-12">
            <table class="table table-border">
                <tbody>
                    <tr v-for="(row,i) in rows" :key=i>
                        <th style="width:45%">
                            {{ row.title }} <br>
                            {{ images[row.code].created_at }} <br>
                            {{ images[row.code].username }}
                        </th>
                        <td style="width:40%"> 
                            <img @click="showImage = row.code" :src="imageUrl + images[row.code].filename" alt="" height="60">
                            <vue-easy-lightbox
                                :visible="showImage == row.code"
                                :imgs="imageUrl +  images[row.code].filename"
                                @hide="showImage = null"
                            ></vue-easy-lightbox>
                        </td>
                        <td>
                            <button v-if="form.action != 'read'" @click="sil(images[row.code].id, row.code)" class="btn btn-outline-danger btn-sm" style="margin-right:4px">Sil</button>
                            <div class="upload-btn-wrapper">
                                <button for="upload" class="btn btn-outline-success btn-sm" style="margin-right:4px">Yükle</button>
                                <input type="file" @change="uploadImage($event, row.code)"  name="images[]" accept="image/*" />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    </Loader>
    <div class="d-flex justify-content-end mt-3">
        <b-button 
            type="submit" 
            @click="close"
            variant="secondary" 
            class="ms-1"
            >Kapat
        </b-button>
    </div>
</b-modal>
</template>
